module.exports = __webpack_public_path__ + "img/leftnav_logo.5857db45.png";